import { ALERTS_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useAlertList } from './hook';
import { AlertListProps } from './props';

export const AlertsList = ({ filters }: AlertListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useAlertList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${ALERTS_DETAIL}/${item.row.id}`, '_blank')
            }
        />
    );
};
